module.exports = __webpack_public_path__ + "img/switch_img1_msg1.af358257.png";